import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectAdvertisers = (state: RootState) => state.advertisers;

export const selectAdvertisersData = createSelector([selectAdvertisers], ({ data, filters, total, dataRequestId }) => ({
  data,
  filters,
  total,
  loading: !!dataRequestId,
}));

export const selectAdvertisersFilters = createSelector([selectAdvertisers], ({ filters }) => filters);

export const selectAdvertisersCategories = createSelector([selectAdvertisers], ({ categories }) => categories);

export const selectSelectedAdvertiser = createSelector(
  [selectAdvertisers],
  ({ selectedAdvertiser }) => selectedAdvertiser,
);
